<template>
  <div>
    <!--page header section start-->
    <!--<section class="page-header position-relative overflow-hidden ptb-120 bg-dark" style="background: url('assets/img/page-header-bg.svg')no-repeat bottom left">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <h1 class="display-5 fw-bold text-white">Shop</h1>
                    <p>Modern, reliable kid phones with built-in parent management</p>
                </div>
            </div>
            <div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light right-5"></div>
        </div>
    </section>-->    
    <section class="shopping-cart">
        <div class="container">
            <nav aria-label="breadcrumb" class="d-flex justify-content-end">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="https://www.mywingio.com/" class="underline-none" >Home</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)" class="underline-none" @click="$router.push({ path: '/'})">Shop</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Cart</li>
                </ol>
            </nav>
            <div v-if="cartItems.length > 0">
                <div class="row gy-4">
                    <div class="col-12">
                        <div class="card cart-card p-3 d-flex flex-row align-items-center mb-2" v-for="cart in cartItems" :key="cart._id">
                            <img :src="cart.productDetail.mainImage" :alt="cart.productDetail.name" class="cart-img me-3">
                            <div class="flex-grow-1 text-start">
                                <!-- Product Name -->
                                <h2 class="text-start product-name unset-font-weight" >{{ cart.productDetail.displayName }}</h2>
                                <small class="text-start text-black unset-font-weight" >{{ cart.productDetail.name }}</small>
                                
                                <!-- Subscription Info -->
                                <p class="mb-1 text-muted small">
                                <strong>Wingio Subscription:</strong>
                                <span class="text-decoration-line-through">{{ cart.qty }} x £{{ cart.subscriptionPlanDetails.stripePriceDetail.unit_amount / 100 }} / month</span>
                                <span class="badge bg-primary ms-2">60 days free</span>
                                </p>

                                <!-- Final Price (if applicable) -->
                                <p class="mb-1 fw-semibold">Total: £{{ (cart.productDetail.stripePriceDetail.unit_amount / 100) * cart.qty }}</p>

                                <!-- Quantity & Remove -->
                                <div class="d-flex align-items-center mt-2">
                                    <label class="me-2 mb-0 small">Qty:</label>
                                    <input type="number"  min="1" v-model="cart.qty" class="form-control form-control-sm quantity-input me-2"  max="5" @change="updateCartQty(cart)">
                                    <a href="javascript:void(0)" @click="deleteCartItem(cart._id)"><i class="fas fa-trash-alt fa-fw text-danger"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                        <div class="col-12">
                            <div class="cart-summary text-center">
                            <h5 class="mb-3">Summary</h5>

                            <!-- Pricing Breakdown -->
                            <div class="d-flex justify-content-between mb-2">
                                <span>Subtotal</span>
                                <span>£{{ subTotal }}</span>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                                <span>Shipping</span>
                                <span>£4.9</span>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between fw-bold mb-3">
                                <span>Total</span>
                                <span>£{{ subTotal + 4.90 }}</span>
                            </div>

                            <form class="pt-3" @submit.prevent="stripeCheckout">
                                <div class="form-group p-1">
                                    <input type="email" class="form-control" v-model="email" placeholder="Enter email">
                                </div>
                                <p class="form-group p-1 text-start">
                                    <input type="checkbox" class="text-start small" v-model="acceptPolicy"> I have read and agree to the <a href="https://www.mywingio.com/terms-conditions">Terms & Conditions</a>, and <a href="https://www.mywingio.com/privacy">Privacy</a> Policy.
                                </p>
                                <!--<div class="form-group p-1">
                                    <input type="text" class="form-control" v-model="phoneNumber" placeholder="Enter Phone Number">
                                </div>-->
                            </form>
                            <button type="button" class="btn btn-primary" @click="stripeCheckout()" :disabled="isDisabled">
                                Checkout <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                            </div>
                        </div>
                </div> 
            </div> 
            <h4 class="text-start pt-2" v-else>Empty cart.</h4>

        </div>
    </section>
  </div>
</template>

<script>
import {useToast} from 'vue-toast-notification';
const $toast = useToast();
import PaymentService from "../services/PaymentService";
import stripeSubscriptionPlanDetail from "@/data/stripeSubscriptionPlanDetail.json"; // Adjust path if needed
let stripe = Stripe(process.env.VUE_APP_STRIPE_PK);
export default {
  name: 'Cart',
  components: {
    
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
      cartItems: [],
      subTotal: 0,
      stripeSubscriptionPlanDetail: stripeSubscriptionPlanDetail,
      email:"",
      password:"",
      childName: "",
      phoneNumber:"",
      acceptPolicy: true
    };
  },
  methods: {
    async getCartItems() {
        await PaymentService.getCartItems()
        .then((response) => {
          this.cartItems = response.data.data;
          this.subTotal = response.data.subTotal;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async updateCartQty(cart) {
        if (cart.qty <= 0) {
            cart.qty = 1;
        }
        let data = {
            cartId: cart._id,
            qty: cart.qty
        }
        await PaymentService.updateCartQty(data)
        .then((response) => {
          $toast.success(response.data.respones_msg);
          this.getCartItems();
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async deleteCartItem(cartId) {
        let data = {
            cartId: cartId,
        }
        await PaymentService.deleteCartItem(data)
        .then((response) => {
          $toast.success(response.data.respones_msg);
          this.getCartItems();
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async stripeCheckout() {
        if (this.acceptPolicy == false) {
            return $toast.error("Please accept the Shipping, Returns, and Warranty Policy to proceed with your order.");   
        }
        this.isDisabled = true;
        let data = { email: this.email, phoneNumber: this.phoneNumber }
        await PaymentService.stripeCheckout(data)
        .then((response) => {
          $toast.success(response.data.respones_msg);
          window.location.href = response.data.data
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    }
  },
  async beforeMount() {
    this.getCartItems();
  },
  created () {
  },
}
</script>
<style scoped>
.cart-card {
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    border: none;
}
.cart-img {
    width: 100%;
    max-width: 100px;
    object-fit: cover;
    border-radius: 8px;
}
.quantity-input {
    width: 70px;
}
.remove-btn {
    font-size: 0.85rem;
}
.cart-summary {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.fw-semibold {
    font-weight: 600 !important;
}
</style>